import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import { Configuration } from '../../app.constants';

@Injectable({
  providedIn: 'root'
})
export class TrainingService {

  constructor(
    private router: Router,
    private _http: HttpClient,
    private config:Configuration,
  ) { }


  addCourse(course){
    return this._http.post(`${this.config.ServerApiUrl}/training/create`,course);
  }

  getCourse(ids){
    return this._http.post(`${this.config.ServerApiUrl}/training/read`,{ids:ids});
  }

  getAllCourses(searchQuery,sort,skip,limit){
    return this._http.post(`${this.config.ServerApiUrl}/training/search`,{search:searchQuery,sort:sort,skip:skip,limit:limit});
  }

  updateCourse(course){
    return this._http.post(`${this.config.ServerApiUrl}/training/update`,course);

  }

  archiveCourse(courseId:string){
    return this._http.post(`${this.config.ServerApiUrl}/training/archive`,{id:courseId});

  }
}
